import { useState } from "react";
import { Banknote, CreditCard, Smartphone } from "lucide-react";
import { money } from "../lib/pos";

/* ---------- Split Payment modal ---------- */
export function SplitModal({ total, onCancel, onSubmit }) {
  const [cash, setCash] = useState("");
  const [card, setCard] = useState("");
  const [upi, setUpi] = useState("");
  const n = (v) => Math.max(0, Number(v) || 0);
  const sumPaisa = Math.round((n(cash) + n(card) + n(upi)) * 100);
  const totalPaisa = Math.round(total * 100);
  const remaining = (totalPaisa - sumPaisa) / 100;
  const canSubmit = sumPaisa === totalPaisa && [n(cash), n(card), n(upi)].filter((x) => x > 0).length >= 2;
  const setRemainingTo = (setter, otherA, otherB) => {
    const rem = Math.max(0, (totalPaisa - Math.round((n(otherA) + n(otherB)) * 100)) / 100);
    setter(rem ? String(rem) : "");
  };
  return (
    <div className="modal-backdrop" onClick={(e) => e.target.classList.contains("modal-backdrop") && onCancel()}>
      <div className="modal" style={{ width: "min(460px, 92vw)" }}>
        <div className="section-line">
          <h2>Split payment</h2>
          <button data-testid="split-close-button" onClick={onCancel}>×</button>
        </div>
        <p className="muted" style={{ fontSize: 12, margin: "0 0 12px" }}>
          Total to settle <b style={{ color: "#e9c46a" }}>{money(total)}</b> — enter any two or three amounts that sum to the total.
        </p>
        <div className="split-inputs">
          <label className="field">
            <span><Banknote size={13} style={{ verticalAlign: "middle", marginRight: 4 }} />Cash</span>
            <div className="split-row">
              <input data-testid="split-cash-input" type="number" min="0" step="1" placeholder="0" value={cash} onChange={(e) => setCash(e.target.value)} />
              <button data-testid="split-cash-remaining" className="outline" onClick={() => setRemainingTo(setCash, card, upi)} type="button">Rest</button>
            </div>
          </label>
          <label className="field">
            <span><CreditCard size={13} style={{ verticalAlign: "middle", marginRight: 4 }} />Card</span>
            <div className="split-row">
              <input data-testid="split-card-input" type="number" min="0" step="1" placeholder="0" value={card} onChange={(e) => setCard(e.target.value)} />
              <button data-testid="split-card-remaining" className="outline" onClick={() => setRemainingTo(setCard, cash, upi)} type="button">Rest</button>
            </div>
          </label>
          <label className="field">
            <span><Smartphone size={13} style={{ verticalAlign: "middle", marginRight: 4 }} />UPI</span>
            <div className="split-row">
              <input data-testid="split-upi-input" type="number" min="0" step="1" placeholder="0" value={upi} onChange={(e) => setUpi(e.target.value)} />
              <button data-testid="split-upi-remaining" className="outline" onClick={() => setRemainingTo(setUpi, cash, card)} type="button">Rest</button>
            </div>
          </label>
        </div>
        <div className="split-summary" data-testid="split-summary">
          <div><span>Entered</span><b>{money(sumPaisa / 100)}</b></div>
          <div className={remaining === 0 ? "ok" : "off"}>
            <span>{remaining >= 0 ? "Remaining" : "Over by"}</span>
            <b>{money(Math.abs(remaining))}</b>
          </div>
        </div>
        <button data-testid="split-submit-button" className="primary wide" disabled={!canSubmit}
          onClick={() => onSubmit({ cash: n(cash), card: n(card), upi: n(upi) })}>
          Record split payment
        </button>
      </div>
    </div>
  );
}
